module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Paul’s Circumstances")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Situation at Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Paul’s Greek Text")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Purpose(s)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Literary and Rhetorical Aspects")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Outline")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Principal Themes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Immediate Results of Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Romans through the Centuries")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter Opening (1:1–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salutation (1:1–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thanksgiving (1:8–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theme (1:16–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Body of the Letter (1:18–15:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Need for God’s Saving Righteousness (1:18–3:20)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gospel of God’s Righteousness Manifest in Sinners’ Justification by Faith (3:21–4:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Justification and New Life in Christ Mean (Chs. 5–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gospel of God’s Righteousness and the Unbelief of (Much of) Israel (Chs. 9–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Meaning for Everyday Life of God’s Justifying Righteousness (12:1–15:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter Closing, 15:14–16:23 (25–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "back"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/back#back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get the Complete Commentary!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0